import { render, staticRenderFns } from "./ffc_partner.vue?vue&type=template&id=c268023a"
import script from "./ffc_partner.vue?vue&type=script&lang=js"
export * from "./ffc_partner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports